var path = 'widget/lib/alarm-status-filter-panel.tpl.html';
var html = "\n\n<md-content style=\"height: 100%\" flex layout=\"column\" class=\"md-padding\">\n    <label class=\"tb-title\" translate>alarm.alarm-status-filter</label>\n    <md-radio-group ng-model=\"vm.subscription.alarmSearchStatus\" class=\"md-primary\">\n        <md-radio-button ng-value=\"searchStatus\" aria-label=\"{{ ('alarm.search-status.' + searchStatus) | translate }}\" class=\"md-primary md-align-top-left md-radio-interactive\" ng-repeat=\"searchStatus in vm.types.alarmSearchStatus\">\n            {{ ('alarm.search-status.' + searchStatus) | translate }}\n        </md-radio-button>\n    </md-radio-group>\n</md-content>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/lib/alarm-status-filter-panel.tpl.html
// module id = 1532
// module chunks = 1